// Default envelope used for every new group card and invitation until the user edits it.
// Keep in sync with the default in backend user_profile/views.py (UserDefaultCardSettings).

export interface EnvelopeAppearance {
  envelopeColor: string;
  fontFamily: string;
  liningImage: string;
  textColor: string;
}

export const DEFAULT_ENVELOPE_APPEARANCE: EnvelopeAppearance = {
  // "Gradient 14" in the envelope editor (soft peach)
  envelopeColor: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
  fontFamily: 'dancing-script-regular',
  // "Nature" inner lining
  liningImage: '/assets/images/cover/15.png',
  // "Wine" text colour
  textColor: '#6B2236',
};

export const DEFAULT_ENVELOPE_STAMP = '/assets/images/stamps/1.png';
